// extracted by mini-css-extract-plugin
module.exports = {"postList":"post-list-module--postList--3a_A5","postListItem":"post-list-module--postListItem--c86c8"};